import React, {Component} from 'react';
import MatchWhenLoggedIn from './../MatchWhenLoggedIn';
import {Route, Redirect, Switch} from 'react-router-dom';
import CommesseList from './CommesseList'
import CommesseForm from './CommesseForm'

class CommesseContent extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (<div>
            <Switch>
                <Route exact path='/app/commesse' render={() => (
                    <Redirect
                        to='/app/commesse/list'
                    />
                )} />
                <MatchWhenLoggedIn path='/app/commesse/list' component={CommesseList} />
                <MatchWhenLoggedIn path='/app/commesse/view/:id' component={CommesseForm} />
                <MatchWhenLoggedIn path='/app/commesse/edit/:id' component={CommesseForm} />
                <MatchWhenLoggedIn path='/app/commesse/new' component={CommesseForm} />
            </Switch>
        </div>)
    }
}

export default CommesseContent;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseContent.js
 **/